import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from 'reactstrap'
import SimpleBar from 'simplebar-react'
import FeatherIcon from "feather-icons-react";
import { useQuery } from 'react-query';
import { queryKeyes } from 'shared/queryKeys';
import { NotificationInbox } from 'VesselMaster/vesselMaster.hooks';
import NotificationDropdownItems from './NotificationDropdownItems';
import { countInboxMessages } from 'GenericForms/Helper';
import ErrorComponent from 'Components/ErrorComponent';
import Loading from 'Components/Loading';
import { NotificationListLimit } from 'shared/constants';

const NotificationDropdown = () => {
    const { data: notificationInboxObj, isError: notificationInboxError, isLoading: notificationInboxLoading }:
        { data: any, isError: any, isLoading: any } = useQuery
            ([queryKeyes.notification.NotificationInbox.key],
                async () => { return await NotificationInbox(queryKeyes.notification.NotificationInbox.url()) },
                {
                    staleTime: Infinity
                })
    const [menu, setMenu] = useState(false);
    const firstTenItems = notificationInboxObj?.results?.length > NotificationListLimit ? 
    notificationInboxObj?.results?.slice(0, NotificationListLimit) : notificationInboxObj?.results;
    return (
        <React.Fragment>
            <Dropdown
                isOpen={menu}
                toggle={() => setMenu(!menu)}
                className="dropdown d-inline-block"
                tag="li"
            >
                <DropdownToggle
                    className="btn header-item noti-icon position-relative"
                    tag="button"
                    id="page-header-notifications-dropdown"
                >
                    <FeatherIcon icon="bell" className="icon-lg me-2" />
                    <span className="badge bg-danger rounded-pill">{!(notificationInboxError || notificationInboxLoading)
                        && countInboxMessages(notificationInboxObj?.count ?? 0)}</span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                    <div className="p-3">
                        <Row className="align-items-center">
                            <Col>
                                <h6 className="m-0">Notifications</h6>
                            </Col>
                        </Row>
                    </div>
                    <SimpleBar style={{ height: "230px" }}>
                        {(notificationInboxError) && <ErrorComponent message='Unable to load required data!' />}
                        {(notificationInboxLoading) && <Loading message='Loading required data!' />}
                        {!(notificationInboxError || notificationInboxLoading) && notificationInboxObj?.results?.length > 0 ?
                            (firstTenItems?.map((notification: any) => (
                                <NotificationDropdownItems {...notification} />))) :
                            (<div className="m-1 alert alert-info alert-dismissible fade show" role="alert">
                                <i className="mdi mdi-alert-circle-outline me-2"></i> There is no unseen messages
                            </div>)}
                    </SimpleBar>
                    <div className="p-2 border-top d-grid">
                        <Link
                            className="btn btn-sm btn-link font-size-14 btn-block text-center"
                            to="/notifications"
                        > <i className="mdi mdi-arrow-right-circle me-1"></i>{" "}View all{" "}
                        </Link>
                    </div>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    )
}

export default NotificationDropdown